import { render } from "./CoursePanelButton.vue?vue&type=template&id=3f80afdd&scoped=true"
import script from "./CoursePanelButton.vue?vue&type=script&lang=js"
export * from "./CoursePanelButton.vue?vue&type=script&lang=js"

import "./CoursePanelButton.vue?vue&type=style&index=0&id=3f80afdd&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f80afdd"]])

export default __exports__